module.exports = __webpack_public_path__ + "img/NewMiniBusIcon.ed16fba1.svg";